let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iy7la")).then(() => parcelRequire('8Egc9'));